var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.12,
    height: 22.53,
    viewBox: "0 0 20.12 22.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.47 -0.85)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-1.47 -0.85)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.53,23.3",
    transform: "translate(-1.47 -0.85)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.63,15.41",
    transform: "translate(-1.47 -0.85)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "map-user"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.59,19.79c-.05,1-1,1.63-1.47,1.94a9.6,9.6,0,0,1-2.28.91,10,10,0,0,1-1,.3,14.49,14.49,0,0,1-1.53.28c-.65.08-1.12.1-2,.13s-1.28,0-2,0a24.62,24.62,0,0,1-2.62-.17A23.26,23.26,0,0,1,6,22.79a13,13,0,0,1-2.65-.85,3.11,3.11,0,0,1-1.53-1.11,2.17,2.17,0,0,1-.33-1,2.24,2.24,0,0,1,.41-1.42,3.06,3.06,0,0,1,1.28-.87c.29-.14.21-.07.92-.36.42-.17,1-.33,1-.33a1.5,1.5,0,0,1,1,.13.87.87,0,0,1,.29.66c0,.36-.45.76-.75.89s-.57.2-1,.36a3.2,3.2,0,0,0-.66.27c-.31.16-.55.3-.58.52s.21.51.56.68a9.5,9.5,0,0,0,1.35.53,11.39,11.39,0,0,0,2.16.4,31,31,0,0,0,3.85.29c.62,0,1.11,0,1.27,0s.89,0,1.78-.12,1.29-.13,2-.26c.39-.08.81-.2,1.65-.44a5.63,5.63,0,0,0,1.17-.52c.28-.16.47-.31.49-.52a.51.51,0,0,0-.15-.34,1.35,1.35,0,0,0-.75-.45,6.37,6.37,0,0,0-.69-.21,3.69,3.69,0,0,1-.91-.3,2,2,0,0,1-.37-.53c0,.29-.06-.64.15-.85a.91.91,0,0,1,.44-.21,1,1,0,0,1,.27,0,5,5,0,0,1,1.4.3,8.38,8.38,0,0,1,.77.35,4.21,4.21,0,0,1,1.2.89A2.29,2.29,0,0,1,21.59,19.79Z",
    transform: "translate(-1.47 -0.85)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48,17.33C6.05,15,3.37,11.26,4.38,6.82A7.51,7.51,0,0,1,11.88,1h0a7.5,7.5,0,0,1,7.5,5.84c1,4.44-1.68,8.16-4.11,10.5a4.9,4.9,0,0,1-6.8,0ZM5.59,7.09C4.7,11,7.14,14.31,9.35,16.43a3.65,3.65,0,0,0,5.08,0c2.2-2.12,4.63-5.46,3.76-9.34a6.23,6.23,0,0,0-6.31-4.86A6.22,6.22,0,0,0,5.59,7.09Z",
    transform: "translate(-1.47 -0.85)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.29,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88,9.16a5,5,0,1,1,5,5A5,5,0,0,1,6.88,9.16Zm.7,0A4.32,4.32,0,1,0,11.9,4.84,4.33,4.33,0,0,0,7.58,9.16Z",
    transform: "translate(-1.47 -0.85)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.64,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.08,8a1.81,1.81,0,1,1,1.81,1.8A1.81,1.81,0,0,1,10.08,8Zm.47,0a1.34,1.34,0,1,0,1.34-1.33A1.34,1.34,0,0,0,10.55,8Z",
    transform: "translate(-1.47 -0.85)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.35,12.74a2.26,2.26,0,0,0-2.46-2,2.25,2.25,0,0,0-2.46,2,.24.24,0,0,1-.24.24A.23.23,0,0,1,9,12.74a2.72,2.72,0,0,1,2.93-2.43,2.72,2.72,0,0,1,2.93,2.43.24.24,0,0,1-.24.24A.23.23,0,0,1,14.35,12.74Z",
    transform: "translate(-1.47 -0.85)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapUser);
export default __webpack_public_path__ + "static/media/map-user.496b8ce0ae9bcebdd128a1a9b72a3b0e.svg";
export { ForwardRef as ReactComponent };